// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from 'D:/gitspace/coffee-bean/safone-cbs-web/src/models/app';
import model_2 from 'D:/gitspace/coffee-bean/safone-cbs-web/src/models/beans';
import model_3 from 'D:/gitspace/coffee-bean/safone-cbs-web/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'app', model: model_1 },
model_2: { namespace: 'beans', model: model_2 },
model_3: { namespace: '@@initialState', model: model_3 },
} as const
